import React, { useRef, useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
    NestedFieldSet,
    FormGroupSelect,
    FormGroupInput,
} from "components/formElements";
import {
    getOptions,
    minYearOfCompletion,
    maxYearOfCompletion,
    minScore,
    maxScore,
    stepScore,
} from "util/library";
import {
    getCommonErrorMessage,
    getScoreErrorMessage,
    getYearOfCompletionErrorMessage,
} from "util/validations";
import Select from 'react-select';
import { getReactSelectOptions, CustomPlaceholder, customStyles } from "util/library";

const Graduation = ({
    handleChange,
    handleGradStreamChange,
    graduationStreams,
    graduationStream,
    graduationStreamName,
    graduationScore,
    graduationCollegeOrUniversity,
    graduationYear,
}) => {
    const gradSelectRef = useRef(null);
    const scoreRef = useRef(null);
    const yearOfCompletionRef = useRef(null);

    const [
        yearOfCompletionErrorMessage,
        setYearOfCompletionErrorMessage,
    ] = useState(
        getYearOfCompletionErrorMessage(yearOfCompletionRef, graduationYear, true)
    );

    useEffect(() => {
        setYearOfCompletionErrorMessage(
            getYearOfCompletionErrorMessage(yearOfCompletionRef, graduationYear, true)
        );
    }, [graduationYear]);

    //const handleStreamChange = () => {
    //    const { options, selectedIndex, value } = gradSelectRef.current;
    //    handleGradStreamChange(
    //        value,
    //        Number(value) === -1 ? "" : options[selectedIndex].text
    //    );
    //};
    const handleStreamChange = (selected) => {
        const value = selected?.value ?? "";
        const label = Number(value) === -1 ? "" : selected?.label ?? "";
        handleGradStreamChange(value, label);
    };


    return (
        <NestedFieldSet legendText="Graduation">
            {/*<FormGroupSelect*/}
            {/*  selectRef={gradSelectRef}*/}
            {/*  id="graduationStream"*/}
            {/*  name="graduationStream"*/}
            {/*  label="Stream"*/}
            {/*  options={getOptions(graduationStreams, "Select Graduation Stream*")}*/}
            {/*  value={graduationStream}*/}
            {/*  onChange={handleStreamChange}*/}
            {/*  required*/}
            {/*/>*/}

            {/*<div style={{ width: "48%", marginTop: "4px" }}>*/}
                <Select
                    id="graduationStream"
                    name="graduationStream"
                    options={getReactSelectOptions(graduationStreams)} // assuming this formats like [{ value, label }]
                    value={getReactSelectOptions(graduationStreams).find(
                        (opt) => opt.value === graduationStream
                    )}
                    onChange={handleStreamChange}

                    placeholder={<CustomPlaceholder text="Select Graduation Stream" />}
                styles={customStyles}
                    isClearable={true}

                />
            {/*</div>*/}
            {Number(graduationStream) === -1 && (
                <FormGroupInput
                    type="text"
                    id="graduationStreamName"
                    name="graduationStreamName"
                    label="Graduation Stream Name"
                    //placeholder="Graduation Stream Name"
                    value={graduationStreamName}
                    onChange={handleChange}
                    errorMessage={getCommonErrorMessage(
                        graduationCollegeOrUniversity,
                        "Graduation Stream",
                        true
                    )}
                    required
                    // eslint-disable-next-line no-useless-escape
                    pattern={"[a-z|A-Z]{1}[a-z|A-Z|.]{1}(a-z|A-Z| |.)*"}
                />
            )}
            <FormGroupInput
                    type="number"
                    min={minScore}
                    max={maxScore}
                    step={stepScore}
                    id="graduationScore"
                    name="graduationScore"
                    label="Score(%)"
                    //placeholder="Score(%)"
                    value={graduationScore}
                    onChange={handleChange}
                    inputRef={scoreRef}
                    errorMessage={getScoreErrorMessage(scoreRef, graduationScore, true)}
                    required
                />
            <FormGroupInput
                type="text"
                id="graduationCollegeOrUniversity"
                name="graduationCollegeOrUniversity"
                label="College/ University"
                //placeholder="Graduation College/ University"
                value={graduationCollegeOrUniversity}
                onChange={handleChange}
                errorMessage={getCommonErrorMessage(
                    graduationCollegeOrUniversity,
                    "College/ University name",
                    true
                )}
                required
                // eslint-disable-next-line no-useless-escape
                pattern={"[a-z|A-Z]{1}[a-z|A-Z|.\\s]{1}(a-z|A-Z| |.)*"}
            />
            <FormGroupInput
                min={minYearOfCompletion}
                max={maxYearOfCompletion}
                id="graduationYear"
                name="graduationYear"
                label="Year of Completion"
                //placeholder="Year of Completion (e.g. 2014)"
                value={graduationYear}
                onChange={handleChange}
                inputRef={yearOfCompletionRef}
                errorMessage={yearOfCompletionErrorMessage}
                required
                pattern={"[0-9]{4}"}
            />

            {Number(graduationStream) === -1 && (
                <FormGroupInput style={{ display: "none" }} />
            )}
        </NestedFieldSet>
    );
};

Graduation.propTypes = {
    handleChange: PropTypes.func.isRequired,
    handleGradStreamChange: PropTypes.func.isRequired,
    graduationStreams: PropTypes.array.isRequired,
    graduationStream: PropTypes.string.isRequired,
    graduationScore: PropTypes.string.isRequired,
    graduationCollegeOrUniversity: PropTypes.string.isRequired,
    graduationYear: PropTypes.string.isRequired,
};

export { Graduation };

